import { renderSlot as _renderSlot, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = {
  class: "wbtn-array topbar-labels",
  style: {"grid-column":"1"}
}
const _hoisted_2 = {
  key: 0,
  class: "wbtn-array bottom-bar",
  style: {"grid-column":"3"}
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["toolbar navigation-bar", _ctx.hasRightGroup ? 'with-right-group' : 'without-right-group'])
  }, [
    _createElementVNode("div", _hoisted_1, [
      _renderSlot(_ctx.$slots, "main-group", {}, undefined, true)
    ]),
    (_ctx.hasRightGroup)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _renderSlot(_ctx.$slots, "right-group", {}, undefined, true)
        ]))
      : _createCommentVNode("", true)
  ], 2))
}